import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@wk/components-v3-react16/all.min.css'; // All components styles
import '@wk/components-v3-react16/theme-PDS-v3.min.css';
import { AllEnterpriseModule, ModuleRegistry } from 'ag-grid-enterprise';

import App from './App';
import ModalContainer from './components/Modals/ModalContainer/ModalContainer';
import { ToastContainer } from './components/Toasts/ToastContainer';
import { store } from './redux/store';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import '@webcomponents/custom-elements/src/native-shim';
import { BrowserRouter } from 'react-router-dom';

const container = document.querySelector('#root');
const root = ReactDOM.createRoot(container as HTMLElement);
const queryClient = new QueryClient();

ModuleRegistry.registerModules([AllEnterpriseModule]);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <BrowserRouter>
          <App />
          <ModalContainer />
          <ToastContainer />
        </BrowserRouter>
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
